import * as React from "react";
import * as _ from "lodash";
import { MultiValue } from "react-select";
import Select from "react-select/dist/declarations/src/Select";

import * as S from "@styled";
import { MultiCreatable } from "shared/components/select/Select";
import { Option } from 'shared/model/Option';
import CustomModal from "shared/components/CustomModal";

const TagModal: React.FC<ITagModalProps> = (props) => {
    const [state, setState] = React.useState<{ selectedTags: Option[], inputValue: string }>({ selectedTags: [], inputValue: "" });
    const tagSelect = React.useRef<Select>();

    React.useEffect(() => {
        setState({ selectedTags: props.currentTags.map((t) => ({ value: t, label: t })), inputValue: "" });
    }, [props.currentTags]);

    const handleTagSelectKeyDown: React.KeyboardEventHandler<HTMLDivElement> = (e) => {
        // Handle comma as a delimiter for completing a tag input
        if (e.code === "Comma") {
            e.preventDefault();
            const value = (tagSelect.current?.state.focusedOption as Option)?.value;
            const alreadyExistsInSelectedTags = state.selectedTags.find(x => x.label === value);
            if (value != null && value != "" && !alreadyExistsInSelectedTags) {
                setState({
                    selectedTags: [...state.selectedTags, { value: value, label: value }],
                    inputValue: ""
                });
            }
        }
    };

    const handleInputChange = (newVal: string) => {
        setState(prevState => ({ ...prevState, inputValue: newVal }));
    }

    const handleChangeSelectedTags = (newSelection: MultiValue<Option<string>>) => {
        if (newSelection === null) {
            setState(prevState => ({ ...prevState, selectedTags: [] }));
        } else {
            setState(prevState => ({ ...prevState, selectedTags: newSelection as Option[] }));
        }
    }

    const handleSave = () => {
        props.onSave(state.selectedTags.map((o) => o.value.toString()));
    }

    return (
        <CustomModal
            label="tagModal"
            onClose={props.onCancel}
            shouldCloseOnOverlayClick={true}
            show={props.show}
            modalTitle={<h2>{FRENDS.Localizations.EditTags}</h2>}
        >
            <S.FormGroup>
                <MultiCreatable
                    ref={tagSelect}
                    options={_.union(props.availableTags, state.selectedTags)}
                    classNamePrefix="react-select"
                    key={`filter-${tagSelect}`}
                    className="tag-select"
                    value={state.selectedTags}
                    inputValue={state.inputValue}
                    onInputChange={handleInputChange}
                    delimiter=","
                    onChange={handleChangeSelectedTags}
                    placeholder={selectPlaceHolderText}
                    onKeyDown={handleTagSelectKeyDown}
                    noOptionsMessage={() => "No Tags found, create new ones by typing"}
                    autoFocus={true}
                    menuPortalTarget={document.body}
                />
            </S.FormGroup>
            <S.ButtonGroup $justifyContentEnd={true} gap={10}>
                <S.Button variant={S.ButtonType.bordered} onClick={props.onCancel}>{FRENDS.Localizations.Cancel}</S.Button>
                <S.Button onClick={handleSave}>{FRENDS.Localizations.SaveChanges}</S.Button>
            </S.ButtonGroup>
        </CustomModal>
    );
}

export default TagModal;

interface ITagModalProps {
    show: boolean;
    currentTags: string[];
    availableTags: Option[];
    onSave: (tags: string[]) => void;
    onCancel: () => void;
}

export const selectPlaceHolderText = FRENDS.Localizations.Select + "...";

export const handleCreateNewTagPromptText = (label: string) => {
    return `${FRENDS.Localizations.CreateNew} ${FRENDS.Localizations.Tag.toLowerCase()} '${label}'`;
};